import styled from "styled-components";

export const VisuallyHidden = styled.span`
  visibility: hidden;
`;
